var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "el-select",
        {
          attrs: {
            loading: _vm.loading,
            placeholder: "Filtrar por",
            "no-match-text": "No hay ningun informe con tu búsqueda",
            size: "small",
            "filter-method": _vm.updateFilter,
            filterable: "",
            clearable: "",
          },
          on: { focus: _vm.onFocus },
          model: {
            value: _vm.selected,
            callback: function ($$v) {
              _vm.selected = $$v
            },
            expression: "selected",
          },
        },
        _vm._l(_vm.options, function (item) {
          return _c(
            "el-option",
            {
              key: item.value,
              attrs: { label: item.label, value: item.value },
            },
            [
              _c("div", { staticClass: "item" }, [
                _c("span", { staticClass: "description" }, [
                  _vm._v(_vm._s(item.label)),
                ]),
              ]),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }